var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLink4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09033 10.97L6.44033 8.62C6.44033 8.62 6.50033 8.6 6.52033 8.62L8.90033 11C8.90033 11 8.96033 11.02 8.98033 11L11.9503 8.03",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4504 9.42998L12.5404 7.73998C12.5404 7.62998 12.4504 7.53 12.3404 7.54L10.6504 7.62999",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78021 17.28C13.0936 17.28 16.5902 13.7833 16.5902 9.47C16.5902 5.15666 13.0936 1.66 8.78021 1.66C4.46687 1.66 0.970215 5.15666 0.970215 9.47C0.970215 13.7833 4.46687 17.28 8.78021 17.28Z",
    stroke: "white",
    strokeWidth: 1.39,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 19.19L14.3003 14.99",
    stroke: "white",
    strokeWidth: 1.39,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLink4);
export default __webpack_public_path__ + "static/media/ActiveLink4.eccb89d9679f0a73b77761cf4d160c3f.svg";
export { ForwardRef as ReactComponent };